import styled from "styled-components";
import { NavLink, useNavigate } from "react-router-dom";

import { PageHeading } from "@/components/Layout/Parts";
import Button from "@/components/Button";
import ImageToolProjectsList from "./components/ImageToolProjectsList";
import Text from "@/components/Text";
import { Controls, ControlsButton } from "@/components/Controls";
import { TableHeader } from "@/components/Table";

const HeadingsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
`;

const NewSearchButton = styled(Button)`
  padding: 0 32px;
`;

const ImageTool = () => {
  const navigate = useNavigate();

  const navigateToCreateForm = () => {
    navigate(`/general/image-tool/create`);
  };

  return (
    <>
      <Text $type="caption" $color="gray">
        BORED PANDA
      </Text>
      <HeadingsRow>
        <PageHeading>Image Tool</PageHeading>
        <NewSearchButton onClick={navigateToCreateForm}>
          New search
        </NewSearchButton>
      </HeadingsRow>
      <TableHeader>
        <Controls>
          <NavLink
            to="/general/image-tool/type/recents"
            end
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Recents
              </ControlsButton>
            )}
          />
          <NavLink
            to="/general/image-tool/type/favorites"
            end
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Favorites
              </ControlsButton>
            )}
          />
          <NavLink
            to="/general/image-tool/type/automated"
            end
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Automated
              </ControlsButton>
            )}
          />
          <NavLink
            to="/general/image-tool/settings"
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Descriptions
              </ControlsButton>
            )}
          />
        </Controls>
      </TableHeader>
      <ImageToolProjectsList />
    </>
  );
};

export default ImageTool;
